import React, { useEffect, useState, useRef, memo } from 'react';
export const DoubleBanner = memo(function DoubleBanner() {
  const banners = [{
    id: 1,
    title: 'BANNER SIZE',
    subtitle: 'DIMENSIONS',
    description: '50% width (desktop) | 100% width (mobile)',
    image: '',
    bgColor: 'bg-gray-300',
    buttonText: 'Ratio 16:9'
  }, {
    id: 2,
    title: 'BANNER SIZE',
    subtitle: 'DIMENSIONS',
    description: '50% width (desktop) | 100% width (mobile)',
    image: '',
    bgColor: 'bg-gray-300',
    buttonText: 'Ratio 16:9'
  }];
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [activePage, setActivePage] = useState(0);
  const CARDS_PER_PAGE_MOBILE = 1;
  const totalPages = Math.ceil(banners.length / CARDS_PER_PAGE_MOBILE);
  const handleScroll = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const page = Math.round(el.scrollLeft / el.clientWidth);
    setActivePage(page);
  };
  const goToPage = (page: number) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollTo({
      left: page * el.clientWidth,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="container mx-auto px-4" data-id="element-1956" data-mp="30qoy56jmejue">
      {/* Desktop: Side by side */}
      <div className="hidden md:flex flex-row gap-4" data-id="element-1957" data-mp="30si7wupj5k6m">
        {banners.map(banner => <div key={banner.id} className={`relative w-1/2 aspect-video overflow-hidden rounded-lg ${banner.bgColor}`} data-id="element-1958" data-mp="2vtou116bzr5x">
            {banner.image && <img src={banner.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-1959" data-mp="35r38iv8p25vl" />}
            <div className="absolute inset-0 flex flex-col justify-center p-8 text-gray-800" data-id="element-1960" data-mp="1fe448dw496r5">
              <span className="text-sm font-bold bg-white text-gray-600 px-3 py-1 rounded-full w-max mb-3" data-id="element-1961" data-mp="1bd29oad59ivi">
                {banner.subtitle}
              </span>
              <h2 className="text-3xl font-bold mb-2" data-id="element-1962" data-mp="3ffc35x21cmsd">{banner.title}</h2>
              <p className="text-base font-medium mb-4 max-w-xs" data-id="element-1963" data-mp="3fhezeyts7c5j">
                {banner.description}
              </p>
              <button className="bg-white hover:bg-gray-100 text-gray-700 font-bold py-2 px-6 rounded-md w-max text-base" data-id="element-1964" data-mp="3pdi2c6wgjetj">
                {banner.buttonText}
              </button>
            </div>
          </div>)}
      </div>

      {/* Mobile: Paginated Slider */}
      <div className="md:hidden" data-id="element-1965" data-mp="26peekd11kuh">
        <div ref={scrollerRef} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide" data-id="element-1966" data-mp="6z8txmv9yq1x">
          {Array.from({
          length: totalPages
        }).map((_, pageIdx) => {
          const pageItems = banners.slice(pageIdx * CARDS_PER_PAGE_MOBILE, pageIdx * CARDS_PER_PAGE_MOBILE + CARDS_PER_PAGE_MOBILE);
          return <div key={pageIdx} className="flex-shrink-0 w-full snap-start px-1" data-id="element-1967" data-mp="25idlvz7qcj2t" data-mpi={pageIdx}>
                {pageItems.map(banner => <div key={banner.id} className={`relative w-full aspect-video overflow-hidden rounded-lg ${banner.bgColor}`} data-id="element-1968" data-mp="1wg4bragdirpy">
                    {banner.image && <img src={banner.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-1969" data-mp="2p5uujwsyahse" />}
                    <div className="absolute inset-0 flex flex-col justify-center p-4 text-gray-800" data-id="element-1970" data-mp="2k7jl3n6ki9ap">
                      <span className="text-xs font-bold bg-white text-gray-600 px-2 py-1 rounded-full w-max mb-2" data-id="element-1971" data-mp="2fegxdvoh1u2f">
                        {banner.subtitle}
                      </span>
                      <h2 className="text-xl font-bold mb-1" data-id="element-1972" data-mp="37x4dsxsiwkx6">{banner.title}</h2>
                      <p className="text-xs font-medium mb-3 max-w-xs" data-id="element-1973" data-mp="334uguxszqkle">
                        {banner.description}
                      </p>
                      <button className="bg-white hover:bg-gray-100 text-gray-700 font-bold py-2 px-4 rounded-md w-max text-sm" data-id="element-1974" data-mp="2nlruex1zzy6q">
                        {banner.buttonText}
                      </button>
                    </div>
                  </div>)}
              </div>;
        })}
        </div>

        {/* Pagination dots */}
        <div className="flex items-center justify-center gap-2 mt-4" data-id="element-1975" data-mp="36daw90kad676">
          {Array.from({
          length: totalPages
        }).map((_, i) => <button key={i} onClick={() => goToPage(i)} aria-label={`Go to page ${i + 1}`} className={`h-2 rounded-full transition-all ${activePage === i ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300 hover:bg-gray-400'}`} data-id="element-1976" data-mp="3bf05cany79sm" data-mpi={i} />)}
        </div>
      </div>
    </div>;
});